/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerRightDownIcon16Light } from './ArrowDCornerRightDownIcon16Light';
import { ArrowDCornerRightDownIcon16Regular } from './ArrowDCornerRightDownIcon16Regular';
import { ArrowDCornerRightDownIcon16Solid } from './ArrowDCornerRightDownIcon16Solid';
import { ArrowDCornerRightDownIcon20Light } from './ArrowDCornerRightDownIcon20Light';
import { ArrowDCornerRightDownIcon20Regular } from './ArrowDCornerRightDownIcon20Regular';
import { ArrowDCornerRightDownIcon20Solid } from './ArrowDCornerRightDownIcon20Solid';
import { ArrowDCornerRightDownIcon24Regular } from './ArrowDCornerRightDownIcon24Regular';
import { ArrowDCornerRightDownIcon24Solid } from './ArrowDCornerRightDownIcon24Solid';
import { ArrowDCornerRightDownIcon32Regular } from './ArrowDCornerRightDownIcon32Regular';
import { ArrowDCornerRightDownIcon64Regular } from './ArrowDCornerRightDownIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerRightDownIcon16Light,
        regular: ArrowDCornerRightDownIcon16Regular,
        solid: ArrowDCornerRightDownIcon16Solid,
    },
    20: {
        light: ArrowDCornerRightDownIcon20Light,
        regular: ArrowDCornerRightDownIcon20Regular,
        solid: ArrowDCornerRightDownIcon20Solid,
    },
    24: {
        regular: ArrowDCornerRightDownIcon24Regular,
        solid: ArrowDCornerRightDownIcon24Solid,
    },
    32: {
        regular: ArrowDCornerRightDownIcon32Regular,
    },
    64: {
        regular: ArrowDCornerRightDownIcon64Regular,
    },
};
export var ArrowDCornerRightDownIcon = forwardRef('ArrowDCornerRightDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
